var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import CurrencyPickerDesktop from "./CurrencyPickerDesktop";
import CurrencyPickerMobile from "./CurrencyPickerMobile";
import "./CurrencyPicker.types";
import { dispatchEvent, EVENTS } from "../events";
var CurrencyPicker = function (_a) {
    var variant = _a.variant, onClose = _a.onClose, onOpen = _a.onOpen, currencyPickerProps = __rest(_a, ["variant", "onClose", "onOpen"]);
    var handleOpen = function () {
        if (onOpen) {
            onOpen();
        }
        dispatchEvent(EVENTS.CURRENCY_PICKER_OPEN);
    };
    var handleClose = function () {
        if (onClose) {
            onClose();
        }
        dispatchEvent(EVENTS.CURRENCY_PICKER_CLOSE);
    };
    var props = __assign(__assign({}, currencyPickerProps), { onOpen: handleOpen, onClose: handleClose });
    return variant === "desktop" ? (React.createElement(CurrencyPickerDesktop, __assign({}, props))) : (React.createElement(CurrencyPickerMobile, __assign({}, props)));
};
export default CurrencyPicker;
